import {ApolloError} from 'apollo-client';
import {useMemo} from 'react';

import {checkIfTeamMemberOrAdmin} from '../Team/utils';
import {
  EntityPageQuery,
  Member,
  useEntityPageQuery,
} from './../../generated/graphql';
import {useViewer} from './../../state/viewer/hooks';

export type EntityPageData = {
  initialLoading: boolean;
  isTeamMemberOrAdmin: boolean;
  data: EntityPageQuery[`entity`];
  error: ApolloError | undefined;
  loading: boolean;
  isViewerLoggedIn: boolean;
};

export enum EntityType {
  Organization = 'organization',
  Team = 'team',
  Personal = 'personal',
}

export function useEntityPageData(entityName: string): EntityPageData {
  const viewer = useViewer();
  const {data, error, loading} = useEntityPageQuery({
    variables: {entityName},
  });

  const {members = []} = data?.entity || {};
  const isTeamMemberOrAdmin = checkIfTeamMemberOrAdmin(
    viewer,
    members as Partial<Member[]>
  );

  const initialLoading = loading && !data;

  const isViewerLoggedIn = viewer != null;

  return useMemo(
    () => ({
      initialLoading,
      isTeamMemberOrAdmin,
      isViewerLoggedIn,
      data: data?.entity,
      error,
      loading,
    }),
    [
      initialLoading,
      isTeamMemberOrAdmin,
      data?.entity,
      error,
      loading,
      isViewerLoggedIn,
    ]
  );
}
